export default {"src":"/_next/static/media/twitter.aa32a0f8.svg","height":23,"width":22};